<template>
  <v-container>
    <v-row align="center" justify="center" width="100%">
      <v-card light :flat="print" style="width: 28cm">
        <v-card-text>
          <h1 style="line-height: 32px;" v-html="reportTitle"></h1>
          <v-row>
            <v-col xs="12" class="mt-1">
              <v-row>
                <v-col xs="6" class="text-right">
                  <img responsive :src="logoPath"/>
                  <br/>
                  <span v-html="contactInfo ? $root.newLineToBR(contactInfo) : null"></span>
                </v-col>
                <v-col xs="6">
                  <v-simple-table dense class="mb-5">
                    <template v-slot:default>
                      <tbody>
                      <tr>
                        <th class="text-left" colspan="2">
                          <h1>Totals</h1>
                        </th>
                      </tr>
                      <tr>
                        <td class="text-left">Loads Count</td>
                        <td class="text-left">{{totalsCounts.loads.toLocaleString()}}</td>
                      </tr>
                      <tr>
                        <td class="text-left">Rate per mile Solo/Team</td>
                        <td class="text-left">${{driverSoloRate}}/${{driverTeamRate}}</td>
                      </tr>
                      <tr>
                        <td class="text-left">Total Miles By Map</td>
                        <td class="text-left">{{totalsCounts.totalMilesByMap.toLocaleString()}} {{$t('milesShort')}}</td>
                      </tr>
                      <tr>
                        <td class="text-left">Total Miles By Odometer</td>
                        <td class="text-left">{{totalsCounts.totalMilesByOdometer.toLocaleString()}} {{$t('milesShort')}}</td>
                      </tr>
                      <tr>
                        <td class="text-left">Total Rate By Map</td>
                        <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{totalsCounts.totalRateByMap.toLocaleString()}}</td>
                      </tr>
                      <tr>
                        <td class="text-left">Total Rate By Odometer</td>
                        <td class="text-left"><v-icon small class="mr-1">fa-dollar-sign</v-icon>{{totalsCounts.totalRateByOdometer.toLocaleString()}}</td>
                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <br/>
              <br/>
              <v-simple-table dense
                              style="border: 1px solid #000; background: transparent;"
                              class="text-left">
                <tbody>
                <tr style="background:#015aaa;color:#fff;page-break-inside: avoid;">
                  <th class="report_font_size text-center">#</th>
                  <th class="report_font_size_normal text-center">Started<br/>Ended</th>
                  <th class="report_font_size_normal text-center">Locations</th>
                  <th class="report_font_size_normal text-center">Load Number<br/>Load UID</th>
                  <th class="report_font_size_normal text-center">Trucks<br/>Drivers</th>
                  <th class="report_font_size_normal text-center">Miles By<br/>Maps / Odometer</th>
                  <th class="report_font_size_normal text-center">Rate By ${{driverSoloRate}}<br/>Maps / Odometer </th>
                </tr>
                <tr v-for="entry in entries" style="page-break-inside: avoid;">
                  <td class="report_font_size_normal">{{entry.id}}</td>
                  <td class="report_font_size_normal">
                    <div class="text-no-wrap">{{entry.startedPST}}</div>
                    <div class="text-no-wrap">{{entry.endedPST}}</div>
                  </td>
                  <td class="report_font_size_normal">
                    <!--<template v-if="driverName">
                      <template v-for="locationEntry in entry.locations">
                        <v-icon small class="mr-2" :color="$root.getLocationColor(locationEntry)">{{$root.getLocationIcon(locationEntry)}}</v-icon>{{locationEntry.name}}<br/>
                      </template>
                    </template>-->
                    <!--<template v-else>-->
                    <div class="text-no-wrap" style="max-width: 150px; text-overflow: ellipsis; overflow: hidden;">
                      {{entry.name.split('--')[0]}}
                    </div>
                    <div class="text-no-wrap" style="max-width: 150px; text-overflow: ellipsis; overflow: hidden;">
                      {{entry.name.split('--')[1]}}
                    </div>
                    <!--</template>-->
                  </td>
                  <td class="report_font_size_normal">
                    <span class="text-no-wrap">{{entry.loadNumber}}</span>
                    <br/>
                    <span class="text-no-wrap">{{entry.uid}}</span>
                  </td>
                  <td class="report_font_size_normal">
                    <template v-for="(truck, index) in entry.trucks">
                      <div class="text-no-wrap">
                        {{truck.truckName}}&nbsp;
                        <template v-for="(driver, index) in truck.drivers">
                          {{driver.driverInitials}}&nbsp;
                        </template>
                      </div>
                    </template>
                  </td>
                  <td class="report_font_size_normal text-center">
                    <!--{{entry.milesByMaps.toLocaleString()}}&nbsp;/&nbsp;{{entry.milesByOdometer.toLocaleString()}} {{$t('milesShort')}}-->
                    {{entry.milesByMaps.toLocaleString()}}&nbsp;/&nbsp;{{entry.milesByOdometer.toLocaleString()}} {{$t('milesShort')}}
                  </td>
                  <td class="report_font_size" v-if="entry.isPaid">
                    {{$t('Reports.Paid')}}&nbsp;${{parseFloat(entry.rateByMaps).toLocaleString()}}/{{parseFloat(entry.rateByOdometer).toLocaleString()}}
                    <br/><label class="report_font_size text-no-wrap">{{entry.payedDateTime}}</label>
                  </td>
                  <td v-else class="report_font_size_normal text-center">
                  <!--  ${{parseFloat(parseFloat(entry.Rate).toFixed(2)).toLocaleString()}}-->
                    ${{parseFloat(entry.rateByMaps).toLocaleString()}}/{{parseFloat(entry.rateByOdometer).toLocaleString()}}
                  </td>
                </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>

export default {
  name: 'DriverLoadsReportTemplate',
  props: ['entries', 'totalsCounts', 'print', 'from', 'to', 'driverName', 'driverSoloRate', 'driverTeamRate'],
  components: {},
  data: function () {
    return {
      publicPath: process.env.BASE_URL,
      contactInfo: '',
      logoPath: ''
    };
  },
  computed: {
    reportTitle () {
      let result = (this.driverName ? this.driverName : 'All Drivers') + '<br/>' + this.$root.t('Report') + ' ' + (this.$route.params.report_number ? '#' + this.$route.params.report_number : '') + ': ';
      if (this.entries && this.entries.length > 1) {
        result += this.entries[0].startedPST.substring(0, 10) + ' - ' + this.entries[this.entries.length - 1].startedPST.substring(0, 10);
      }
      if (this.entries && this.entries.length === 1){
        result += this.entries[0].startedPST.substring(0, 10);
      }
      return result;
    }
  },
  mounted () {
    this.$root.getInvoiceLogoPath().then(path => {
      this.logoPath = path;
    });
    this.$root.getGlobalSettingsField('invoiceContactInfo', this.companyId).then((response) => {
      if (response.status === 'ok') {
        this.contactInfo = response.result;
      }
    });
    document.title = this.reportTitle.replace('<br/>', ' ');
  },
  methods: {
  }
};
</script>
